import { ReactNode, useState } from "react";
import { Carousel } from "react-bootstrap";
import Link from "./Link";

export type CarouselItem = {
    interval?: number;
    image: string;
    link?: string;
    linkTitle?: string;
    className?: string;
    altText?: string;
    title?: ReactNode;
    subTitle: ReactNode;
    info?: ReactNode;
}

type Props = {
    id: string;
    items: Array<CarouselItem>;
    interval?: number;
    prevIcon?: ReactNode;
    nextIcon?: ReactNode;
}

export default function CustomCarousel(props: Props) {
    const {items, interval = 3000, prevIcon, nextIcon} = props;
    const [index, setIndex] = useState<number>(0);
  
    const handleSelect = (selectedIndex: number) => {
      setIndex(selectedIndex);
    };

    return (
        items.length ? <Carousel
            id={props.id}
            activeIndex={index}
            onSelect={handleSelect}
            interval={interval}
            prevIcon={prevIcon}
            nextIcon={nextIcon}
        >
            {items.map((item: CarouselItem, index: number) => {
                const {interval, link, linkTitle, className, image, altText, title, subTitle, info} = item;

                return <Carousel.Item
                    key={index}
                    interval={interval ? interval : interval}
                >
                    {link ? <Link href={link} title={linkTitle}>
                        <img
                            className={className}
                            src={image}
                            alt={altText}
                        />
                    </Link> : <img
                        className={className}
                        src={image}
                        alt={altText}
                    />}
                    {(title || subTitle || info) && (<Carousel.Caption>
                        {title && <h2>{title}</h2>}
                    </Carousel.Caption>)}
                </Carousel.Item>
            })}
        </Carousel> : <div className="text-center py-4">Nessun elemento da visualizzare</div>
    )
}